/*
THIS CODE WORKS WITH BACK IN STOCK API from SureSwift APP
https://apps.shopify.com/back-in-stock
 */

$(function() {
        const BACKINSTOCK = {
            $addToCart: $("[data-btn-add-to-cart]"),
            $backInStock: $("[data-btn-back-in-stock]"),
            loaded: false,
            backInStockIframe: document.getElementById('BIS_frame')
        }

        BACKINSTOCK.init = function(){
            BACKINSTOCK.backInStockIframe = document.getElementById('BIS_frame');

            if (!BACKINSTOCK.backInStockIframe) return;

            var backInStockIframeBody = BACKINSTOCK.backInStockIframe.contentDocument.body;
            $(backInStockIframeBody).append('<link rel="stylesheet" href="https://use.typekit.net/drz6hgc.css">');
          $(backInStockIframeBody).append('<style>#container {font-family: "futura-pt", sans-serif !important;}.btn-success {font-size: 24px; line-height: 1.4;letter-spacing: normal; padding: 4px 25px; font-weight: 400; background-color: var(--light__brand_secondary); border: none;}#email_address:focus {outline: none;box-shadow: none;background-color: #fff;font-size: 15px;}#email_address {border: 0.5px solid #6B7280;background-color: #fff;max-width: 100%;padding: 4px 8px;border-radius: 4px;box-shadow: none;-webkit-font-smoothing: antialiased;-webkit-text-size-adjust: 100%;text-rendering: optimizeLegibility;width: 100%;line-height: 1;height: auto;appearance: none;font-size: 15px;}</style>');

            // Translations
            if(window._BIS_i18n) {
                var $modalTitle = $(backInStockIframeBody).find('.modal-title');
                var $modalDesc = $modalTitle.find('+ p');
                var $emailInput = $(backInStockIframeBody).find('[type="email"]');
                var $modalButton = $(backInStockIframeBody).find('[type="submit"]');
                var $modalDisclaimer = $(backInStockIframeBody).find('form + .small-print');
                var $modalError = $(backInStockIframeBody).find('.alert-danger');
                var $modalSuccess = $(backInStockIframeBody).find('.alert-success');
                $modalTitle.html(window._BIS_i18n.modal_title);
                $modalDesc.html(window._BIS_i18n.modal_description);
                $emailInput.get(0).setAttribute('placeholder', window._BIS_i18n.modal_placeholder);
                $modalError.html(window._BIS_i18n.error);
                $modalSuccess.html(window._BIS_i18n.success);
                $modalButton.html(window._BIS_i18n.modal_button);
                $modalDisclaimer.html(window._BIS_i18n.modal_disclaimer);
                BACKINSTOCK.$backInStock.html(window._BIS_i18n.button);
            }

            // End Translations

            BACKINSTOCK.loaded = true;
        }

        $('[data-product-form]').on('mousedown', function(){
            if(BACKINSTOCK.loaded) return;

            BACKINSTOCK.init();
        });

        $('.product-template').on('variantChange', function(e){
            if(typeof BIS !== 'undefined' && typeof BISConfig !== 'undefined') {
                if(e.variant) {
                    if (!e.variant.available) {
                        BACKINSTOCK.$addToCart.hide();
                        BACKINSTOCK.$backInStock.attr('data-variant-id', e.variant.id);
                        BACKINSTOCK.$backInStock.show();
                    } else {
                        BACKINSTOCK.$addToCart.show();
                        BACKINSTOCK.$backInStock.hide();
                    }
                }
            }
        });
});
